import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { LogOut, Settings, Trophy } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useProfile } from '../../hooks/useProfile';
import useClickOutside from '../../hooks/useClickOutside';

const UserMenu = () => {
  const { user, signOut } = useAuth();
  const { profile } = useProfile();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useClickOutside(menuRef, () => setIsOpen(false));

  if (!user) return null;

  const avatarUrl = profile?.avatar_url || `https://api.dicebear.com/7.x/identicon/svg?seed=${user.id}`;

  return (
    <div ref={menuRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 p-1 rounded-lg hover:bg-background"
      >
        <img
          src={avatarUrl}
          alt="User avatar"
          className="w-8 h-8 rounded-lg border border-gray-800"
          key={avatarUrl} // Key will force re-render when URL changes
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-background-secondary rounded-lg shadow-lg border border-gray-800 py-1">
          <div className="px-4 py-2 border-b border-gray-800">
            <p className="text-sm font-medium text-content-primary">
              {profile?.display_name || 'Anonymous User'}
            </p>
            <p className="text-xs text-content-secondary truncate">
              {user.email}
            </p>
          </div>
          <Link
            to="/profile"
            className="flex items-center gap-2 px-4 py-2 text-sm text-content-secondary hover:text-content-primary hover:bg-background"
          >
            <Settings className="w-4 h-4" />
            Profile Settings
          </Link>
          <Link
            to="/profile/trophies"
            className="flex items-center gap-2 px-4 py-2 text-sm text-content-secondary hover:text-content-primary hover:bg-background"
          >
            <Trophy className="w-4 h-4" />
            My Trophies
          </Link>
          <button
            onClick={signOut}
            className="w-full flex items-center gap-2 px-4 py-2 text-sm text-content-secondary hover:text-content-primary hover:bg-background"
          >
            <LogOut className="w-4 h-4" />
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;